import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class ClientsDataService {

    constructor(private http: HttpClient) {
    }

    // Create new client
    createClient(clientData: object) {
        return this.http.post('agri/crm/createCompany', clientData);
    }

    // Get all companies
    getAllCompanies() {
        return this.http.get('agri/crm/getAllCompanies');
    }

    // Get company by id
    getCompanyById(companyId: string) {
        return this.http.get('agri/getCompanyById?companyId=' + companyId);
    }

    // Get jobs from company
    getAllJobsFromCompany(companyId: string) {
        return this.http.get('agri/getAllJobsFromCompany?companyId=' + companyId);
    }

    // Update client
    updateClient(companyId: string, clientData: object) {
        return this.http.put('agri/updateCompany?companyId=' + companyId, clientData);
    }

    listCompaniesFiltered(size, page, sort, order, companiesData: object) {
        return this.http.post('agri/listCompaniesFiltered?page=' + (page-1) + '&size=' + size + '&sort=' + sort + '&dir=' + order, companiesData);
    }

}
